import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';
import { TmGiftCardRequest } from '../../tscapi/model/request/account_cart-request';
import { checkGiftCardBalance } from '../../tscapi/service/accountcart.service';
import { AccountUtils } from '../../tscapi/utils/account-utils';
import { Cookie } from '../../tscapi/utils/cookie';
import Input from '../common/input';
import InputPin from '../common/input-pin';

export const Giftcard = () => {
    const { cartData, applyGiftCard, clearGiftCard, setIsLoading, orderModificationMode } = useContext(CartContext);

    let appliedGiftMessage = '';
    if (cartData && cartData.GiftCards && cartData.GiftCards.length > 0) {
        appliedGiftMessage = cartData.OrderSummary.GiftCard + ' applied to your order today!';
    }

    const cookie: Cookie = new Cookie();
    let isOrderModMode = false;
    if (cookie.ModifyOrderNumber && cookie.ModifyOrderNumber.length > 0) {
        isOrderModMode = true;
    }
    const [giftCardNumber, setGiftCardNumber] = useState('');
    const [giftCardPin, setGiftCardPin] = useState('');
    const [giftCardAppliedMessage, setAppliedMessage] = useState(appliedGiftMessage);
    const [giftCardErrorMessage, setErrorMessage] = useState('');

    const { t } = useTranslation();

    const onGiftCardNumberChange = (e) => {
        setErrorMessage('');
        setGiftCardNumber(e.target.value);
    };
    const onGiftCardPinChange = (e) => {
        setErrorMessage('');
        setGiftCardPin(e.target.value);
    };
    const startsWith = (str, temp) => {
        return str.lastIndexOf(temp, 0) === 0;
    };
    const applyCartGiftCard = async () => {
        const giftCardReq = new TmGiftCardRequest();
        giftCardReq.CardNumber = giftCardNumber.trim().replace(/\s/g, '');
        giftCardReq.PIN = giftCardPin.trim();
        if (giftCardReq.CardNumber && giftCardReq.PIN) {
            try {
                setIsLoading(true);
                if (cartData.OrderSummary.EasyPay && cartData.OrderSummary.EasyPay.NoOfInstallments > 1) {
                    setErrorMessage(t('Gift cards cannot be used for orders that have Easy Pays.'));
                    setIsLoading(false);
                    return;
                }

                const giftCardBalance = await checkGiftCardBalance(giftCardReq);
                if (giftCardBalance && giftCardBalance.data) {
                    try {
                        if (giftCardBalance.data == '$0.00') {
                            setErrorMessage('The gift card entered has zero balance.');
                            setIsLoading(false);
                        } else {
                            await applyGiftCard(giftCardReq);
                            setAppliedMessage(giftCardBalance.data + ' applied to your order today!');
                            setIsLoading(false);
                        }
                    } catch (error) {
                        setErrorMessage(
                            AccountUtils.getErrorMessage(error, t('Unable to apply this gift card. Please try again.')),
                        );
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                }
            } catch (error) {
                console.log(error);
                setErrorMessage(
                    AccountUtils.getErrorMessage(error, t('Unable to apply this gift card. Please try again.')),
                );
                setIsLoading(false);
            }
        } else {
            setErrorMessage('PIN is required.');
        }
    };

    const clearCartGiftCard = () => {
        if (cartData.GiftCards && cartData.GiftCards.length > 0) {
            try {
                clearGiftCard(cartData.GiftCards[0].Id.toString());
                setGiftCardNumber('');
                setGiftCardPin('');
            } catch (error) {
                setErrorMessage(
                    AccountUtils.getErrorMessage(error, t('Unable to remove this gift card. Please try again.')),
                );
            }
        }
    };
    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            applyCartGiftCard();
        }
    };
    useEffect(() => {
        if (cartData && cartData.OrderSummary.EasyPay == null && cartData.GiftCards.length == 0) {
            setErrorMessage('');
            setIsLoading(false);
        }
    }, [cartData]);

    if (cartData) {
        return (
            <>
                {!isOrderModMode && (
                    <div className="giftcard__container formWrap">
                        <h3 className="promocode__title">{t('Enter Gift Card')}</h3>
                        {cartData && cartData.GiftCards && cartData.GiftCards.length > 0 ? (
                            <>
                                <div className="promoremove__container">
                                    <div className="form__input promocode__code">
                                        {t('ending in')} {cartData.GiftCards[0].MaskedNumber.slice(-4)}
                                    </div>
                                    <button className="promocode__button--remove" onClick={clearCartGiftCard}>
                                        {t('Remove')}
                                    </button>
                                </div>
                                {giftCardAppliedMessage && (
                                    <div>
                                        <b>{giftCardAppliedMessage}</b>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="giftcard__inputwrap">
                                    <Input
                                        id="giftcardNumber"
                                        mask="giftcard"
                                        error={giftCardErrorMessage}
                                        name="giftcard"
                                        value={giftCardNumber}
                                        type="tel"
                                        onChange={onGiftCardNumberChange}
                                    />
                                </div>
                                <div className="giftcard__spacer"></div>
                                <div className="giftcard__pinwrap">
                                    <label className="giftcard__label">{t('PIN')}:</label>
                                    <InputPin
                                        classProp="form__input giftcard__input--small"
                                        id="giftcardPin"
                                        mask="pin"
                                        error={giftCardErrorMessage}
                                        name="pin"
                                        value={giftCardPin}
                                        type="tel"
                                        onChange={onGiftCardPinChange}
                                        onKeyDown={onKeyDown}
                                    />

                                    <button
                                        className="giftcard__button--white button"
                                        data-link-type="link"
                                        data-link-title="gift card"
                                        data-component-type="express checkout"
                                        onClick={applyCartGiftCard}
                                    >
                                        {t('Apply')}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </>
        );
    }
};
